import { CheckCircle } from "@phosphor-icons/react";
import { BENEFITS } from "@/data/site";

export default function BenefitsBar() {
  return (
    <section className="border-y border-white/10 bg-brand-red" data-testid="benefits-bar">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-x-8 gap-y-3 px-5 py-5 sm:grid-cols-2 md:px-8 lg:grid-cols-3">
        {BENEFITS.map((b) => (
          <div key={b} className="flex items-center gap-2.5">
            <CheckCircle weight="fill" className="h-5 w-5 shrink-0 text-white" />
            <span className="font-heading text-sm font-medium uppercase tracking-wide text-white">{b}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
